
import useUniversalStore from "store/universalStore";
import { Loader } from "components";

const Sahukari = () => {
    const { user } = useUniversalStore();

    return user ?
        <iframe src={`https://app.sahukari.com/?sessionToken=${user?.getSessionToken()}`} width="100%" height="100%" />
        : <Loader />
}

export default Sahukari;